import Event from '../../core/Event';

export default class EstimationPlaceRequested extends Event {
    public static type = 'EstimationPlaceRequested';

    constructor() {
        super(EstimationPlaceRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationPlaceRequested.ts